<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5 *ngIf="reason.id; else titleBlock" class="modal-title container"
          i18n>
          Editar Motivo de Invalidação
        </h5>
        <ng-template #titleBlock>
          <h5 class="modal-title container" i18n>Novo Motivo de Invalidação</h5>
        </ng-template>
      </div>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body">
      <form [formGroup]="reasonForm" (submit)="onSubmit()">

        <!-- Contrato + Habilitado -->
        <div class="row">
          <div class="col-9">
            <div class="form-group">
              <app-input i18n-label="@@ContractLabel" type="select"
                formControlName="contractId" inputRequired=true
                label="Contrato" [inputDisabled]="reason.id"
                [list]="contracts" i18n-placeholder
                placeholder="Selecione o contrato" selectValue="id"
                selectText="prettyName">
              </app-input>
            </div>
          </div>
          <div class="col-3">
            <label i18n>Habilitado?
              <div class="custom-control custom-switch">
                <div class="form-group mt-1">
                  <label class="custom-control-label"
                    [ngClass]="{checked: reasonForm.get('enabled').value}">
                    <input type="checkbox"
                      class="form-control custom-control-input"
                      formControlName="enabled">
                  </label>
                </div>
              </div>
            </label>
          </div>
        </div>

        <!-- Código, Nome, Código do Cliente -->
        <div class="row">
          <div class="col col-md-3">
            <div class="form-group">
              <app-input i18n-label="@@Code" type="text" formControlName="code"
                inputRequired=true label="Código" [inputDisabled]="reason.id">
              </app-input>
            </div>
          </div>
          <div class="col col-md-6">
            <div class="form-group">
              <app-input i18n-label="@@Name" type="text"
                inputRequired=true formControlName="name" label="Nome">
              </app-input>
            </div>
          </div>
          <div class="col col-md-3">
            <div class="form-group">
              <app-input type="text" formControlName="clientCode"
                label="Código do Cliente">
              </app-input>
            </div>
          </div>
        </div>

        <!-- Tipo + Enquadramento (condicional) -->
        <div class="row">
          <div class="col col-md-4">
            <div class="form-group">
              <app-enum-i18n [input]="reasonTypes"
                (output)="reasonTypesI18n=$event"></app-enum-i18n>
              <app-input i18n-placeholder="@@ReasonTypes"
                i18n-label="@@ReasonTypesLabel"
                type="select" [list]="reasonTypesI18n" label="Tipo"
                formControlName="type"
                selectText="value" selectValue="id"
                placeholder="{{ reasonType }}"
                [inputRequired]="!isOnlyTraffic">
              </app-input>
            </div>
          </div>
          <div class="col col-md-8" *ngIf="showEnquadramento">
            <div class="form-group">
              <app-input i18n-label i18n-placeholder
                placeholder="Selecione os enquadramentos"
                label="Enquadramento(s)"
                type="multiselect" selectText="shortDescription"
                selectValue="id" [list]="regulations"
                selectShowLimit=3
                formControlName="regulationIds">
              </app-input>
            </div>
            <div class="loading-spinner" *ngIf="loading">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </div>
        </div>

        <!-- Módulos de Utilização -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="modules-container p-3">
              <label class="d-block mb-2" i18n><strong>Módulos de
                  Utilização</strong></label>
              <div class="d-flex align-items-center">
                <div class="module-option mr-3"
                  [ngClass]="{'module-option--active': moduleViolation}"
                  (click)="toggleViolation()">
                  <span class="module-checkbox">
                    <i class="material-icons"
                      *ngIf="moduleViolation">check_box</i>
                    <i class="material-icons"
                      *ngIf="!moduleViolation">check_box_outline_blank</i>
                  </span>
                  <span class="module-label ml-1">Infração</span>
                  <i class="material-icons module-icon ml-2">info</i>
                </div>
                <div class="module-option"
                  [ngClass]="{'module-option--active': moduleTraffic}"
                  (click)="toggleTraffic()">
                  <span class="module-checkbox">
                    <i class="material-icons"
                      *ngIf="moduleTraffic">check_box</i>
                    <i class="material-icons"
                      *ngIf="!moduleTraffic">check_box_outline_blank</i>
                  </span>
                  <span class="module-label ml-1">Passagem</span>
                  <i class="material-icons module-icon ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#1f1f1f"><path d="M80-80q-17 0-28.5-11.5T40-120v-320l85-203q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T640-80h-40q-17 0-28.5-11.5T560-120v-40H160v40q0 17-11.5 28.5T120-80H80Zm72-440h415l-33-80H186l-34 80Zm-32 280h480v-200H120v200Zm142.5-57.5Q280-315 280-340t-17.5-42.5Q245-400 220-400t-42.5 17.5Q160-365 160-340t17.5 42.5Q195-280 220-280t42.5-17.5Zm280 0Q560-315 560-340t-17.5-42.5Q525-400 500-400t-42.5 17.5Q440-365 440-340t17.5 42.5Q475-280 500-280t42.5-17.5ZM720-200v-344l-73-176H227l18-43q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T760-200h-40Zm120-120v-344l-73-176H347l18-43q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T880-320h-40Zm-480-20Z"/></svg>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Telas (condicional) -->
        <div *ngIf="showTelas" id="accordion">
          <div class="card pb-2">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <div class="col-md-12 btn btn-link">
                  <div class="row" data-toggle="collapse"
                    data-target="#collapseScreen" aria-expanded="true"
                    aria-controls="collapseScreen"
                    (click)="toggleCollapse(showArea)">
                    <div class="col-md-11">
                      <p class="text-left" i18n>Exibir este motivo de
                        invalidação nas telas:</p>
                    </div>
                    <div class="col-md-1">
                      <p class="mb-1 text-right">
                        <i class="material-icons" *ngIf="!showArea"
                          data-toggle="collapse" data-target="#collapseScreen"
                          aria-expanded="true"
                          aria-controls="collapseScreen">expand_more</i>
                        <i class="material-icons" *ngIf="showArea"
                          data-toggle="collapse" data-target="#collapseScreen"
                          aria-expanded="false"
                          aria-controls="collapseScreen">expand_less</i>
                      </p>
                    </div>
                  </div>
                </div>
              </h5>
            </div>
            <div id="collapseScreen" class="collapse"
              aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body pb-2">
                <div class="row">
                  <div class="col">
                    <label i18n>Cadastros Básicos</label>
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="exemptPeriod" i18n>Período
                          Isento</mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <label i18n>Pré-Processamento</label>
                    <div class="row mt-1">
                      <div class="col-md-4">
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="quarantine"
                              i18n>Quarentena</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="triage"
                              i18n>Triagem</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="typing"
                              i18n>Digitação</mat-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="verifyValid" i18n>Verificação de
                              Válidas</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="verifyInvalid" i18n>Verificação
                              de Inválidas</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="validate"
                              i18n>Validação</mat-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="audit"
                              i18n>Auditoria</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="serialNumberConfig"
                              i18n>Gerenciar Série</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="preProcessConfig"
                              i18n>Configuração de
                              Pré-Processamento</mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <label i18n>eCS Spy</label>
                    <div class="row mt-1">
                      <div class="col-md-4">
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="verifyCFTV" i18n>Verificação
                              Infrações CFTV</mat-checkbox>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary"
                              formControlName="validateCFTV" i18n>Validação
                              Infrações CFTV</mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="onCancel()">
        <app-loading [promise]="promise" text="Cancelar"
          i18n-text></app-loading>
      </button>
      <button class="btn btn-primary" (click)="onSubmit()"
        [ngClass]="{disabled: !isValid}">
        <app-loading [promise]="promise" text="Confirmar"
          i18n-text></app-loading>
      </button>
    </div>
  </div>
</div>
